import React from 'react';
import { Box, Typography } from '@mui/material';

export const Home: React.FC = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -55%)', // Slightly above center
                width: '100%',
                maxWidth: 'md',
                textAlign: 'center'
            }}
        >
            <Box
                component="img"
                src="/bananaverse-logo.png"
                alt="Bananaverse Logo"
                sx={{
                    width: '60%',
                    maxWidth: 500,
                    mb: 4
                }}
            />

            <Typography variant="h5" component="h1" gutterBottom>
                Screen-to-Page Adaptations
            </Typography>

            <Typography variant="body1" sx={{ mb: 4, maxWidth: '80%', mx: 'auto' }}>
                Coming Soon!
            </Typography>
        </Box>
    );
};